import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useFeatureFlag from 'hooks/Optimizely/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

function KidsFlyFreeTermsAndConditions() {
  const intl = useIntl()
  const childrenFlyFreeEnabled = useFeatureFlag(OptimizelyFeatureFlags.childrenFlyFree)

  if (!childrenFlyFreeEnabled) return null

  const title = intl.formatMessage({
    id: '92q9UoHZ-Z-5MZlIvYe8',
    defaultMessage: 'Kids Fly Free Terms & Conditions',
    description: 'Heading for kids fly free terms and conditions section',
  })

  const paragraph1 = intl.formatMessage({
    id: 'rM-oCxXZa4l6bs3nyxdS',
    defaultMessage: 'Kids (2–11 years) fly free on Maldives bundled packages only. Offer valid on packages purchased between 28 February – 29 March 2026. Not valid on standalone flights.',
    description: 'Kids fly free terms and conditions paragraph 1 in the terms and conditions section',
  })

  const paragraph2 = intl.formatMessage({
    id: 'ryrAHhEMU2LwuM4XLJQy',
    defaultMessage: 'Valid for weekly departures and return flights with the following travel periods (unless sold out): 8 June – 21 June 2026 or 27 July – 20 September 2026. Economy class seats only. Green tax of $12 USD per person, per day is not included.',
    description: 'Kids fly free terms and conditions paragraph 2 in the terms and conditions section',
  })

  const paragraph3 = intl.formatMessage({
    id: 'afnMRhBvWS6p6AL028ya',
    defaultMessage: '^Save over $1,000 per child is based on an average potential saving of $1,023 per child when booking flights bundled with accommodation. Subject to regulatory and government approval.',
    description: 'Kids fly free terms and conditions paragraph 3 in the terms and conditions section',
  })

  return (
    <Group direction="vertical">
      <BodyText variant="medium" weight="bold">
        {title}
      </BodyText>
      <Group direction="vertical" gap={8}>
        <BodyText variant="medium">{paragraph1}</BodyText>
        <BodyText variant="medium">{paragraph2}</BodyText>
        <BodyText variant="medium">{paragraph3}</BodyText>
      </Group>
    </Group>
  )
}

export default KidsFlyFreeTermsAndConditions
